class PinNotFoundError extends Error {
  constructor (message, response) {
    super(message)
    this.name = 'PinNotFoundError'
    this.code = 'pinNotFound'
    this.response = response
  }
}

export default PinNotFoundError
